import React from "react";

const VeganFriendly = ({ fill, light, size }) => {
  return (
    <svg
      width={size || "72"}
      height={size || "72"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.17 24.17"
      className="m-1"
    >
      <path
        d="M12.09 24.17C5.42 24.17 0 18.75 0 12.09S5.42 0 12.09 0c6.66 0 12.08 5.42 12.08 12.08s-5.42 12.09-12.08 12.09zm0-23.62C5.73.55.56 5.72.56 12.08c0 6.36 5.17 11.53 11.53 11.53 6.36 0 11.54-5.17 11.54-11.53C23.62 5.73 18.45.55 12.09.55z"
        fill={fill}
      />
      <path
        d="M8.61 7.13l-.27.2L5.51 4.9l.31-.23 2.01 1.81c.07.06.23.24.35.36l.02-.02c-.09-.14-.21-.35-.25-.43L6.8 3.95l.31-.23 1.5 3.41zM9.52 3.03l-.86.31.44 1.21.83-.3.11.29-.83.3.49 1.34.85-.31.11.29-1.2.44L8.2 3.19l1.21-.44.11.28zM11.64 4.11l.93-.05.04.67c.03.57.04 1.3-.81 1.35-.87.05-.99-.75-1.06-1.9-.05-.86.01-1.79.88-1.83.49-.03.75.25.87.64l-.37.15c-.06-.21-.17-.48-.47-.46-.57.04-.56.82-.53 1.46.08 1.35.29 1.64.68 1.62.43-.02.45-.31.41-1.08l-.02-.27-.55.03v-.33zM14.57 6.46l-.39-.1.04-.76-.84-.22-.33.69-.4-.1 1.7-3.32.35.09-.13 3.72zm-.34-1.17l.09-1.42c.01-.25.06-.5.09-.75l-.02-.01c-.1.23-.19.47-.29.69l-.59 1.29.72.2zM16.09 7.43l-.28-.18.53-2.56c.03-.16.09-.32.13-.47l-.02-.02c-.11.21-.21.42-.34.62l-1.18 1.87-.28-.18 1.95-3.08.28.18-.56 2.64c-.03.13-.06.26-.1.39l.01.01c.08-.14.14-.29.23-.43l1.3-2.05.28.18-1.95 3.08z"
        fill={light ? "#595A5A" : "#fff"}
      />
      <g>
        <path
          d="M7.8 16.68l-.6-.71-.98.83.57.67-.24.2-.57-.67-1.32 1.13-.25-.29 2.77-2.37.85 1-.23.21zM6.19 19.66l2.02-3.04.34.23c.47.32.91.65.42 1.39-.26.39-.6.7-1.16.35l-.23 1.98-.33-.22.25-1.95-.01-.01-.99 1.48-.31-.21zm1.45-1.5l.11.08c.44.29.61.21.87-.19.32-.48.19-.64-.21-.9l-.06-.05-.71 1.06zM8.72 21.05l-.35-.14 1.35-3.38.35.14-1.35 3.38zM11.62 18.36l-.89-.17-.24 1.26.86.16-.06.3-.86-.16-.26 1.4.89.17-.06.31-1.26-.24.67-3.57 1.26.24-.05.3zM13.8 21.56l-.33.03-1.14-2.35c-.07-.14-.12-.3-.18-.45h-.02c.04.23.09.46.11.7l.2 2.2-.33.03-.33-3.62.33-.03 1.17 2.43c.06.12.11.24.16.36h.02c-.03-.16-.07-.32-.08-.48l-.22-2.41.33-.03.31 3.62zM13.64 17.87l.38-.16c.72-.3 1.23-.42 1.89 1.19.55 1.32.46 1.78-.47 2.17l-.41.17-1.39-3.37zm1.63 2.94l.1-.04c.68-.28.58-.74.18-1.71-.48-1.16-.72-1.34-1.38-1.06l-.06.03 1.16 2.78zM17.53 19.59l.72-.53.18.25-1.02.76-2.16-2.93.31-.23 1.97 2.68zM18.15 17.3l1.18 1.07-.26.28-1.18-1.07-2.05-.79.27-.3 1.18.52c.15.07.31.14.47.21l.01-.02c-.1-.14-.21-.28-.3-.43l-.62-1.11.27-.3 1.03 1.94z"
          fill={light ? "#595A5A" : "#fff"}
        />
      </g>
      <path
        d="M3.89 16.25c3.47-5.63 7.82-3.6 13.09-6.13-3.13 1.43-7.38.58-10.38 2.43-.58-4 4.45-3.75 7.71-3.31 1.52.21 3.86-.32 5.19-1.53-.08 4.96-5.55 10.92-12.41 6.07-.88.24-2.11 1.12-3.2 2.47z"
        fillRule="evenodd"
        fill={fill}
      />
    </svg>
  );
};

export default VeganFriendly;
